import ChevronRightSmall from './src/chevron-right-small-combined';
export default ChevronRightSmall;